import { WalletAddressLink } from "@/app/components/wallet-address"
import type { CollectionOfferGroup } from "@anaconda/core/nft-collection/collection/types"
import { LISTING_SOURCE_NAME } from "@anaconda/core/nft/listing-source"
import { Badge } from "@rarible_int/anaconda_ui_components"
import { Count } from "../../view/count"

interface Props {
  offerGroup: CollectionOfferGroup
}

export function OfferMakers({ offerGroup }: Props) {
  const maker =
    offerGroup.makers.type === "multiple" ? (
      <Count value={offerGroup.makers.count} />
    ) : (
      <WalletAddressLink
        className="justify-end"
        address={offerGroup.makers.address}
      />
    )

  // An aggregated row is taken on the marketplace it came from, not here — say
  // whose it is, or it reads as one of ours that has lost its action.
  if (!offerGroup.source) return maker

  return (
    <div className="flex items-center justify-end gap-2">
      {maker}
      <Badge variant="secondary" className="whitespace-nowrap">
        {LISTING_SOURCE_NAME[offerGroup.source]}
      </Badge>
    </div>
  )
}
